import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Button,
  Typography,
  Switch,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Storage } from 'aws-amplify';

import CustomForm from '../../Form';

import { useTranslation } from 'react-i18next';
import { schema, uiSchema } from './formObject';
import { useHistory } from 'react-router-dom';
import CardsSlider from './CardsSlider';
import DragAndDrop from '../../UploadForm/DragAndDrop';
import AlertDialog from '../../UI/AlertDialog';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: '100%',
    marginTop: 40,
    marginBottom: 20,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 16,
      paddingRight: 16
    },
    [theme.breakpoints.up('xs')]: {
      paddingLeft: 23,
      paddingRight: 23
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: 23,
      paddingRight: 0
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 41.5,
      paddingRight: 18.5
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: 80,
      paddingRight: 80
    }
  },
  marginRight: {
    marginRight: 32
  },
  typography: {
    marginBottom: 20
  },
  arrowBtn: {
    width: 44,
    height: 44
  }
}));
const checkBundleVersion = (extraConfig) => JSON.parse(extraConfig).enableBundleV2;

const ScreenWithGrids = (props) => {
  const { templates, config, onSubmit, loading, setFiles } = props;

  let history = useHistory();

  const classes = useStyles();
  const submitFormButton = useRef(null);
  const formRef = useRef(null);
  const { t } = useTranslation();

  const flows = config.flows.filter(flow => flow.type === 'document' && flow.visible);

  const [formData, setFormData] = useState({});
  const [selected, setSelected] = useState();
  const [file, setFile] = useState(null);
  const [nameBundle, setNameBundle] = useState('');
  const [fromExcel, setFromExcel] = useState(false);
  const [onlyBundleFlows, setOnlyBundleFlows] = useState(true);
  const [flowTemplates, setFlowTemplates] = useState(flows);
  const [error, setError] = useState(false);
  const [enableBundleV2, setEnableBundleV2] = useState(false);
  const [bundleVersion, setBundleVersion] = useState(1);
  const FILE_TYPES_ACCEPTED = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.odt', '.ods', '.odp'];

  useEffect(() => {
    if (formData) setNameBundle(formData.name);
  }, [formData]);

  useEffect(() => {
    let formData;
    if (templates.length === 1 && fromExcel === false) {
      formData = { ...formData, documentTemplateId: templates[0].id };
      setFormData(formData);
    }
    if (flowTemplates.length === 1) {
      formData = { ...formData, flowTemplateId: flowTemplates[0].templateId };
      setFormData(formData);
    }
  }, [templates, fromExcel]);

  useEffect(() => {
    if (onlyBundleFlows) {
      filterWithSubflows();
    } else {
      setFlowTemplates(flows);
    }
  }, [onlyBundleFlows]);
  useEffect(() => {
    if (bundleVersion === 2) {
      filterTemplatesForV2();
    } else {
      setFlowTemplates(flows);
    }
  }, [bundleVersion]);
  useEffect(() => {
    setEnableBundleV2(checkBundleVersion(config.extraConfig.data));
  }, []);

  const filterWithSubflows = () => {
    const flowsWithSubflows = flows.filter((flow) => {
      const { steps } = flow;
      const subflowStep = steps.find((step) => {
        const { configStep: { step: { type } } } = step;
        if (type === 'subFlows') {
          return true;
        }
        return false;
      });

      if (subflowStep) {
        return true;
      } else {
        return false;
      }
    });
    setFlowTemplates(flowsWithSubflows);
  };

  const handleSelectTemplate = (choosen) => {
    if (choosen !== null) {
      setFormData({
        ...formData,
        documentTemplateId: templates[choosen].id
      });
    }
  };

  const handleSelectFlow = (choosen) => {
    if (choosen !== null) {
      setSelected(flowTemplates[choosen]);
      setFormData({
        ...formData,
        flowTemplateId: flowTemplates[choosen].templateId
      });
    }
  };

  const uploadFilesHelper = async () => {
    if (fromExcel) {
      const filesPromises = file.map(async (file) => {
        const fileName = file.name
          .replace(/\s/g, '_')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        const fileUrl = `bundle/${nameBundle}/document/${fileName}`
          .replace(/\s/g, '_')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        await Storage.put(fileUrl, file, {
          contentType: file.type
        });
        return fileName;
      });
      const files = await Promise.all(filesPromises);
      setFiles(files);
    }
  };
  const renderBundleVersionSelector = () => {
    return (

      <Grid item xs={8} >
        <Grid container direction='column'>
          <Grid item xs={5} >
            <FormControl
              style={{
                width: '100%'
              }}
              variant='outlined' className={classes.formControl}>
              <InputLabel>{t('createBundleWithGrids:bundleVersion')}</InputLabel>
              <Select
                value={bundleVersion}
                onChange={handleBundleChange}
                label={t('createBundleWithGrids:bundleVersion')}
              >
                <MenuItem value={1}>{t('createBundleWithGrids:version1')}</MenuItem>
                <MenuItem value={2}>{t('createBundleWithGrids:version2')}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{
            minWidth: '300px'
          }} xs={5}>
            <Typography variant='subtitle2' style={{
              fontSize: '12',
              margin: '10px',
              color: '#828282'
            }}>{t('createBundleWithGrids:bundleLimitation')} {bundleVersion === 1 ? 50 : 500} {t('createBundleWithGrids:documents')}</Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  };
  const handleChange = () => {
    setFromExcel(!fromExcel);
    if (!fromExcel) delete formData.documentTemplateId;
    setFormData(formData);
  };
  const handleBundleChange = (e) => {
    setBundleVersion(e.target.value);
  };
  const filterTemplatesForV2 = () => {
    const filterdFlowTemplates = flows.filter((flow) => JSON.parse(flow.extraConfig.data).enableBundleV2);
    setFlowTemplates(filterdFlowTemplates);
  };

  const handleOnlyBundleFlows = () => {
    setOnlyBundleFlows(!onlyBundleFlows);
  };

  const handleSubmit = async () => {
    if (!file && fromExcel) {
      setError(true);
    } else {
      await uploadFilesHelper();
      submitFormButton.current.click();
    }
  };

  return (
    <Grid container className={classes.mainContainer}>
      <Grid
        container
        direction='column'
        jutify={loading ? 'center' : undefined}
        alignItems={loading ? 'center' : undefined}
      >
        <Grid container direction='row'>
          <Grid item xs={10}>
            <Typography variant='subtitle1' className={classes.typography}>
              {t('createBundleWithGrids:createBundle')}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            { bundleVersion === 1 && <FormControlLabel
              control={<Switch onChange={handleChange} />}
              label={t('createBundleWithDialog:fromExcel')}
            />}
          </Grid>
        </Grid>
        <Grid container direction='row'>
          <Grid item xs={1} />
          <Grid item xs={6}>
            <Grid container direction='column'>
              { enableBundleV2 && renderBundleVersionSelector()}
              <Grid item xs={5}>
                <CustomForm
                  formRef={formRef}
                  submitFormButton={submitFormButton}
                  schema={schema()}
                  uiSchema={uiSchema}
                  formData={formData}
                  onChange={(form) => setFormData(form.formData)}
                  onSubmit={() => {
                    formData.bundleVersion = bundleVersion;
                    onSubmit(formData);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={1} />
        <Grid item xs={11}>
          <Typography variant='subtitle1' className={classes.typography}>
            {!fromExcel
              ? t('createFlowWithGrids:selectTemplate')
              : t('createBundleWithDialog:uploadDocuments')}
          </Typography>
        </Grid>
      </Grid>
      {fromExcel ? (
        <Grid
          style={{
            width: '100%',
            paddingLeft: '9%'
          }}
          item
          xs={11}
        >
          <DragAndDrop setContent={setFile} accept={FILE_TYPES_ACCEPTED.join(',')} multiple type='bundle' />
        </Grid>
      ) : (
        <CardsSlider selected={selected} setSelected={handleSelectTemplate} items={templates} />
      )}
      <Grid container>

        <Grid item xs={1} />
        <Grid item xs={11}>
          <Typography variant='subtitle1' className={classes.typography}>
            {t('createFlowWithGrids:selectSignType')}
          </Typography>
          <FormControlLabel
            control={<Switch onChange={handleOnlyBundleFlows} />}
            label={t('createBundleWithGrids:onlyBundleFlows')}
            checked={onlyBundleFlows}
          />
        </Grid>
        <CardsSlider setSelected={handleSelectFlow} items={flowTemplates} />
      </Grid>

      <Grid container direction='row'>
        <Grid item xs={1} />
        <Grid container item xl={3} xs={4} justify='flex-start'>
          <Button
            size='medium'
            color='primary'
            onClick={() => {
              history.goBack();
            }}
            disabled={loading}
            className={classes.marginRight}
          >
            {t('createFlowWithGrids:cancel')}
          </Button>
          <Button
            type='submit'
            color='primary'
            variant='contained'
            onClick={handleSubmit}
            disabled={loading}
          >
            {t('createFlowWithGrids:create')}
          </Button>
        </Grid>
      </Grid>

      {error && (<AlertDialog
        description={t('bundleUploadView:noFiles')}
        open={error}
        setOpen={setError}
      />)}

    </Grid>

  );
};

ScreenWithGrids.propTypes = {
  config: PropTypes.object.isRequired,
  templates: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default ScreenWithGrids;
